import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { TotalEffectif } from '@models/stats.model';
import { GuestOrderResponse } from '@models/dashboard/guest-order-response.model';

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  private readonly statsApi = `${environment.portageUrl}/stats`;
  private httpService = inject(HttpService);

  #totalEffectifRefresh = new BehaviorSubject<void>(undefined);

  /** Effectif total, re-chargé à chaque appel de refreshTotalEffectif() */
  readonly totalEffectif$: Observable<TotalEffectif> =
    this.#totalEffectifRefresh.pipe(switchMap(() => this.getTotalEffectif()));

  getTotalEffectif(): Observable<TotalEffectif> {
    return this.httpService.get<TotalEffectif>(
      `${this.statsApi}/total-effectif`
    );
  }

  /** Demande le rafraîchissement du compteur d'effectif */
  refreshTotalEffectif(): void {
    this.#totalEffectifRefresh.next();
  }

  getGuestOrders(
    start: string,
    end: string,
    archived = false
  ): Observable<GuestOrderResponse[]> {
    return this.httpService.post<
      GuestOrderResponse[],
      { start: string; end: string; archived: boolean }
    >(`${this.statsApi}/guest-orders`, { start, end, archived });
  }
}
